/** @type {import('tailwindcss').Config} */
export default {
  theme: {
    extend: {
      colors: {
        primary: {
          '010': '#FFE9EA',
          '020': '#FFC7C8',
          '030': '#FFB1B2',
          '040': '#FF8F90',
          '050': '#FF6D6F',
          '060': '#CC5759',
          '070': '#994143',
          '080': '#662B2D',
          '090': '#4D2022',
        },
        grey: {
          '000': '#FFFFFF',
          '005': '#F9F9F9',
          '010': '#EEEEEE',
          '020': '#CCCCCC',
          '030': '#B3B3B3',
          '040': '#999999',
          '050': '#808080',
          '060': '#666666',
          '070': '#4D4D4D',
          '080': '#333333 ',
          '090': '#1A1A1A',
        },
        yellow: {
          '050': '#FEBD3E',
        },
        system: {
          notice: {
            '040': '#FFE3B0',
            '050': '#FFBF49',
          },
          error: '#FB2121',
          kakao: '#F9E000',
          naver: '#00CA00',
        },
      },
      letterSpacing: {
        xs: '-1px',
        s: '-0.7px',
        m: '-0.5px',
        l: '-0.2px',
        xl: '0px',
      },
      borderRadius: {
        s: '5px',
        m: '10px',
        l: '20px',
        'circular-m': '100px',
      },
      boxShadow: {
        '050': '0px 0px 10px 0px rgba(26, 26, 26, 0.10)',
        '060': '0px 0px 10px 0px rgba(26, 26, 26, 0.20)',
      },
      animation: {
        'fade-in': 'fade-in 0.5s ease-in-out',
        'slide-up': 'slide-up 0.2s ease-out',
      },
      keyframes: {
        'fade-in': {
          from: { opacity: '0' },
          to: { opacity: '1' },
        },
        'dot-flashing': {
          '0%': { 'background-color': 'var(--color-grey-000)' },
          '100%': { 'background-color': 'var(--color-primary-060)' },
        },
        'slide-up': {
          '0%': { transform: 'translateY(100%)' },
          '100%': { transform: 'translateY(0)' },
        },
      },
      screens: {
        mobile: '320px',
        desktop: '1200px',
      },
    },
  },
  plugins: [
    function ({ addBase, theme }) {
      addBase({
        ':root': {
          '--color-grey-000': theme('colors.grey.000'),
          '--color-primary-050': theme('colors.primary.050'),
        },
      });
    },
  ],
};
